/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Diamond: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 12 12" size={size} color={color} {...props}>
      <path
        d="M11.624 5.093a1.283 1.283 0 010 1.814l-4.717 4.717a1.283 1.283 0 01-1.814 0L.376 6.907a1.283 1.283 0 010-1.814L5.093.376a1.283 1.283 0 011.814 0l4.717 4.717z"
        fillRule="evenodd"
      />
    </Icon>
  );
};

export default Diamond;

Diamond.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
